import React from "react";
import LogoutHeader from '../../components/Headers/LogoutHeader';
import LogoutFooter from '../../components/Footers/LogoutFooter';
import Videos from '../../components/Videos';

const VideosPage = () => {
  return (
    <div>
      <LogoutHeader />
      <main>
        <Videos />
      </main>
      <LogoutFooter />
    </div>
  );
};

export default VideosPage;